const PRIORIDAD_OPTIONS = [
  { value: "BAJA", label: "Baja" },
  { value: "MEDIA", label: "Media" },
  { value: "ALTA", label: "Alta" },
  { value: "URGENTE", label: "Urgente" },
];

interface FormStep2Props {
  data: {
    presupuesto_base: string;
    valor_estimado: string;
    fecha_publicacion: string;
    fecha_limite: string;
    prioridad: string;
    url_plataforma: string;
  };
  onChange: (data: Partial<FormStep2Props["data"]>) => void;
  errors: Record<string, string>;
}

const inputClass = (field: string, errors: Record<string, string>) =>
  `w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm ${
    errors[field] ? "border-red-500" : "border-gray-300"
  }`;

export function LicitacionFormStep2({ data, onChange, errors }: FormStep2Props) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="presupuesto_base" className="block text-sm font-medium text-gray-700 mb-1">
            Presupuesto base (EUR)
          </label>
          <input
            id="presupuesto_base"
            type="number"
            step="0.01"
            min="0"
            value={data.presupuesto_base}
            onChange={(e) => onChange({ presupuesto_base: e.target.value })}
            className={inputClass("presupuesto_base", errors)}
            placeholder="0.00"
          />
          {errors.presupuesto_base && <p className="text-sm text-red-500 mt-1">{errors.presupuesto_base}</p>}
        </div>

        <div>
          <label htmlFor="valor_estimado" className="block text-sm font-medium text-gray-700 mb-1">
            Valor estimado (EUR)
          </label>
          <input
            id="valor_estimado"
            type="number"
            step="0.01"
            min="0"
            value={data.valor_estimado}
            onChange={(e) => onChange({ valor_estimado: e.target.value })}
            className={inputClass("valor_estimado", errors)}
            placeholder="0.00"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label htmlFor="fecha_publicacion" className="block text-sm font-medium text-gray-700 mb-1">
            Fecha de publicación
          </label>
          <input
            id="fecha_publicacion"
            type="date"
            value={data.fecha_publicacion}
            onChange={(e) => onChange({ fecha_publicacion: e.target.value })}
            className={inputClass("fecha_publicacion", errors)}
          />
        </div>

        <div>
          <label htmlFor="fecha_limite" className="block text-sm font-medium text-gray-700 mb-1">
            Fecha límite
          </label>
          <input
            id="fecha_limite"
            type="date"
            value={data.fecha_limite}
            onChange={(e) => onChange({ fecha_limite: e.target.value })}
            className={inputClass("fecha_limite", errors)}
          />
          {errors.fecha_limite && <p className="text-sm text-red-500 mt-1">{errors.fecha_limite}</p>}
        </div>
      </div>

      <div>
        <label htmlFor="prioridad" className="block text-sm font-medium text-gray-700 mb-1">
          Prioridad
        </label>
        <select
          id="prioridad"
          value={data.prioridad}
          onChange={(e) => onChange({ prioridad: e.target.value })}
          className={inputClass("prioridad", errors)}
        >
          {PRIORIDAD_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>

      <div>
        <label htmlFor="url_plataforma" className="block text-sm font-medium text-gray-700 mb-1">
          URL de la plataforma
        </label>
        <input
          id="url_plataforma"
          type="url"
          value={data.url_plataforma}
          onChange={(e) => onChange({ url_plataforma: e.target.value })}
          className={inputClass("url_plataforma", errors)}
          placeholder="https://contrataciondelestado.es/..."
        />
      </div>
    </div>
  );
}
